import {
  IPublicClientApplication
} from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import AdvicePageRouter from "pages/AdvicePage/AdvicePageRouter";
import AdviceTimelineGraphPageRouter from "pages/AdviceTimelineGraphPage/AdviceTimelineGraphPageRouter";
import AdviceTimelinePageRouter from "pages/AdviceTimelinePage/AdviceTimelinePageRouter";
import EmployeeDetailPageRouter from "pages/EmployeeDetailPage/EmployeeDetailPageRouter";
import HomePageRouter from "pages/HomePage/HomePageRouter";
import LoginBySSOPage from "pages/LoginPage/LoginBySSOPage";
import LoginPage from "pages/LoginPage/LoginPage";
import MyPageRouter from "pages/MyPage/MyPageRouter";
import PluginGroupwareWebRouter from "pages/Plugin/PluginGroupwareWebRouter";
import PluginOutlookPageRouter from "pages/Plugin/PluginOutlookPageRouter";
import { default as PluginTeamsPageRouter } from "pages/Plugin/PluginTeamsPageRouter";
import TimelineGraphPageRouter from "pages/TimelineGraphPage/TimelineGraphPageRouter";
import TimelinePageRouter from "pages/TimelinePage/TimelinePageRouter";
import { Route, Routes } from "react-router-dom";
import { useRootStore } from "store/StoreContextProvider";
import "./App.css";

type AppProps = {
  pca: IPublicClientApplication;
};

function App({ pca }: AppProps) {
  const { loginStore } = useRootStore();

  return (
    <MsalProvider instance={pca}>
      {loginStore.currentUser && (
        <>
          <div>
            {/* <MaterialListPage /> */}
            <Routes>
              <Route path="/" element={<HomePageRouter />} />
              <Route path="/login" element={<LoginPage />} />

              <Route path="/advice" element={<AdvicePageRouter />} />
              <Route
                path="/advice-timeline"
                element={<AdviceTimelinePageRouter />}
              />
              <Route
                path="/advice-timeline-graph"
                element={<AdviceTimelineGraphPageRouter />}
              />
              <Route path="/timeline" element={<TimelinePageRouter />} />
              <Route
                path="/timeline-graph"
                element={<TimelineGraphPageRouter />}
              />
              <Route path="/mypage/*" element={<MyPageRouter />} />
              <Route
                path="/employee-detail/*"
                element={<EmployeeDetailPageRouter />}
              />
              <Route
                path="/plugin/teams/*"
                element={<PluginTeamsPageRouter />}
              />
              <Route
                path="/plugin/mails/*"
                element={<PluginOutlookPageRouter />}
              />
              <Route
                path="/groupware/advice/*"
                element={<PluginGroupwareWebRouter />} />
            </Routes>
            {/* <Routes>
              <Route path="/*" element={<MaterialRouter />} />
            </Routes> */}
          </div>
        </>
      )}
      {!loginStore.currentUser && (
        <>
          <div>
            <Routes>
              <Route path="" element={<LoginPage />} />
              <Route path="/ssologin" element={<LoginBySSOPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/plugin/teams/*"
                element={<PluginTeamsPageRouter />}
              />
              <Route
                path="/plugin/mails/*"
                element={<PluginOutlookPageRouter />}
              />
              <Route
                path="/groupware/advice/*"
                element={<PluginGroupwareWebRouter />} />
            </Routes>
          </div>
        </>
      )}
    </MsalProvider>
  );
}

export default App;
